import { useState } from "react";
import { Link } from "react-router-dom";

export default function Login() {
  const [email, setEmail] = useState("");
  const [pass, setPass] = useState("");
  // const [errorMessage, setErrorMessage] = useState("");

  async function submitFunction(e) {}

  return (
    <div className="s-u-container">
      <div className="box">
        <div className="start-side" style={{ order: 1 }}>
          <Link className="back-home" to="/">
            <i class="fa-solid fa-arrow-left"></i> Home
          </Link>
          <h2>Hello Friend!</h2>
          <p>Enter Your Personal Detailes And Start With Us</p>
          <Link to="/register" className="btn btn-reverse">
            SIGN UP
          </Link>
        </div>
        <div className="end-side" style={{ order: 0 }}>
          <Link className="back-home" to="/">
            <i class="fa-solid fa-arrow-left"></i> Home
          </Link>
          <h2>Sign In To Our Clinic</h2>
          <div className="sociel-login">
            <i className="fa-brands fa-facebook-f"></i>
            <i className="fa-brands fa-twitter"></i>
            <i className="fa-brands fa-instagram"></i>
          </div>
          <p>or use your email account:</p>
          <form onSubmit={submitFunction}>
            <div className={`email inp-field`}>
              <i className="fa-regular fa-envelope"></i>
              <input
                type="text"
                placeholder="Email"
                name="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>
            <div className={`password inp-field `}>
              <i className="fa-solid fa-lock"></i>
              <input
                type="password"
                placeholder="Password"
                name="pass"
                value={pass}
                onChange={(e) => setPass(e.target.value)}
              />
            </div>
            {/* <p className="error">{errorMessage}</p> */}
            <a className="forget-p" href="/">
              Forget Your Password ?
            </a>
            <input className="btn" type="submit" />
          </form>
        </div>
      </div>
    </div>
  );
}
